import enTranslation from "../__i18n__/en";
import frTranslation from "../__i18n__/fr";

export default {
  lng: "fr",
  fallbackLng: "en",
  resources: {
    en: { translation: enTranslation },
    fr: { translation: frTranslation }
  }
};



// WEBPACK FOOTER //
// ./src/config/i18nConfig.js